import * as React from 'react';

import * as babyBoy from "../images/BabyBoy_XFL.png";
import * as brentRambo from "../images/brentrambo.gif";
import * as drunkDirkNash from "../images/drunk_dirk_nash.jpg";
import * as timmyPau from "../images/pau_sax_timmy_bass.jpg";
import * as goodBoy from "../images/whos_a_good_boy.jpg";

export function ImagePage(): JSX.Element {
    return (
        <div>
            <p>Important images</p>
            <img src={timmyPau} alt="Timmy and Pau playing instruments" />
            <img src={goodBoy} alt="WHOS A GOOD BOY" />
            <img src={drunkDirkNash} alt="a good night" />
            <img src={babyBoy} alt="baby boy" />
            <img src={brentRambo} alt="thumbs up" />
        </div>
    );
}